const state = {
  // 当前登录用户
  user: {
    role: {
      menus: []
    }
  },
  menuTree: [],
  menuClickInOtherPage: {}
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js